export const IconBlog20: {
  name: 'icon_blog_20-cd6a42814cbf'
} = {
  name: 'icon_blog_20-cd6a42814cbf'
}
